@let user = this.user();

<button
  type="button"
  [tp]="profileMenu"
  tpPlacement="bottom"
  tpVariation="menu"
  tpClassName="user-profile-menu"
  class="hover:ring-4 hover:ring-[#a1bccb] hover:border-[#7c81fa] rounded-full transition-all"
>
  @if (user.avatar) {
    <img
      class="rounded-full size-8 min-w-8 object-cover"
      [ngSrc]="user.avatar"
      [alt]="user.fullname"
      width="32"
      height="32"
    />
  } @else {
    <img
      class="rounded-full size-8 min-w-8 object-cover"
      [ngSrc]="'assets/images/brand/safehire-placeholder.png'"
      [alt]="user.fullname"
      width="32"
      height="32"
    />
  }
</button>

<ng-template #profileMenu let-hide>
  <div>
    <ul>
      <li>
        <a
          class="flex items-center gap-2 py-2 px-[14px] w-full !no-underline"
          [routerLink]="['/settings']"
          (click)="hide()"
        >
          <ui-kit-user-settings-fill />
          <span>{{ 'navbar.menu.settings' | transloco }}</span>
        </a>
      </li>

      @if (!isTrial() && isOrganizationOwner()) {
        <li *authRole="[Role.USER]">
          <button
            class="flex items-center gap-2 py-2 px-[14px] w-full !no-underline"
            (click)="createPortalSession(); hide()"
          >
            <ui-kit-wallet-fill />
            <span>{{ portalMenuLabel() | transloco }}</span>
          </button>
        </li>
      }

      <li class="border-t border-mercury-100">
        <button class="flex items-center gap-2 py-2 px-[14px] w-full" (click)="logout.emit()">
          <ui-kit-logout-circle-fill />
          <span>{{ 'common.logout' | transloco }}</span>
        </button>
      </li>
    </ul>
  </div>
</ng-template>
